export default __webpack_public_path__ + "static/media/style-desktop.9557b0d5.jpg";